import React, { useLayoutEffect, useContext, useState } from 'react';
import { Link, NavLink } from 'react-router-dom';
import { UserContext } from '../../api/userContext';
import { ROUTES } from '../../config/routes';
import "../../assets/css/animate.css";
import "../../assets/css/header.css";
// image import
import NavLogo from "../../assets/images/LogoWhite.png";
import Logo from "../../assets/images/LogoGreen.png";

const HomeOneHeader = ({ className = "" }) => {
  const { user, isAdmin } = useContext(UserContext);
  const [isMenuActive, setIsMenuActive] = useState(false);


  const handleHamburgerClick = () => {
    setIsMenuActive(!isMenuActive);
  };

  const handleNavLinkClick = () => {
    setIsMenuActive(false);
    scrollTop();
  };

  const scrollTop = () => {
    window.scrollTo({
      top: 0,
      behavior: "smooth",
    });
  };

  useLayoutEffect(() => {
    // Sticky Navbar
    const handleScroll = () => {
      const headerArea = document.querySelector(".header-area");
      if (window.scrollY >= 20) {
        headerArea.classList.add("sticky");
      } else {
        headerArea.classList.remove("sticky");
      }
    };
    window.addEventListener("scroll", handleScroll);

    // Preloader
    // const preloader = document.querySelector(".preloader");
    // if (preloader) {
    //   setTimeout(() => {
    //     preloader.style.display = "none";
    //   }, 2000);
    // }

    // Cleanup event listeners on component unmount
    return () => {
      window.removeEventListener("scroll", handleScroll);
    };
  }, []);

  return (
    <>
      {/* ===============  header area start =============== */}
      <header className={className}>
        <div className="header-area header-style-one">
          <div className="container">
            <div className="row align-items-center">
              <div className="col-xl-2 col-lg-12 col-md-12 col-12 d-xl-flex align-items-center">
                <div className="logo d-flex align-items-center justify-content-between w-100">
                  <Link
                    onClick={scrollTop}
                    to={'/'}
                    className="logo-white"
                  >
                    <img src={Logo} alt="logo" className="masjidy-logo" />
                  </Link>
                  <div className="mobile-menu d-flex">
                    <Link
                      to={"#"}
                      onClick={handleHamburgerClick}
                      className={`hamburger d-block d-xl-none ${isMenuActive ? 'h-active' : ''}`}
                    >
                      <span className="h-top" />
                      <span className="h-middle" />
                      <span className="h-bottom" />
                    </Link>
                  </div>
                </div>
              </div>
              <div className="col-xl-10 col-lg-12 col-md-12 col-12">
                <nav className={`main-nav ${isMenuActive ? 'slidenav' : ''}`}>
                  <div className="inner-logo d-xl-none">
                    <Link to={"#"} onClick={scrollTop}>
                      <img src={NavLogo} alt="logo" className="masjidy-logo" />
                    </Link>
                  </div>
                  <ul>
                    <li>
                      <NavLink id="home" exact to={ROUTES.HOME.path} onClick={handleNavLinkClick}>
                        <i className="bi bi-house-door me-2"></i> Home
                      </NavLink>
                        
                    </li>
                    <li>
                      <NavLink
                        to={ROUTES.ARTICLES.path}
                        onClick={handleNavLinkClick}
                      >
                        <i className="bi bi-journal-text me-2"></i> Articles
                      </NavLink>
                        
                    </li>
                    <li>
                      <NavLink
                        to={ROUTES.NEWS.path}
                        onClick={handleNavLinkClick}
                      >
                        <i className="bi bi-newspaper me-2"></i> News
                      </NavLink>
                        
                    </li>
                    <li>
                      <NavLink
                        to={ROUTES.QUIZ.path}
                        onClick={handleNavLinkClick}
                      >
                        <i className="bi bi-question-circle me-2"></i> Quiz
                      </NavLink>
                    </li>
                    <li>
                      <NavLink
                        to={ROUTES.DHIKR.path}
                        onClick={handleNavLinkClick}
                      >
                        <i className="bi bi-book me-2"></i> Dhikr
                      </NavLink>
                    </li>
                    <li>
                      <NavLink
                        to={ROUTES.QURAN.path}
                        onClick={handleNavLinkClick}
                      >
                        <i className="bi bi-journal-bookmark me-2"></i> Quran
                      </NavLink>
                    </li>
                    { isAdmin && (
                      <li><NavLink to={ROUTES.DASHBOARD.path} onClick={handleNavLinkClick}><i className="bi bi-speedometer2 me-2"></i> Dashboard</NavLink></li>
                    )}
                    <li>
                      {user ? (
                        <NavLink
                          to={ROUTES.PROFILE.path}
                          onClick={handleNavLinkClick}
                        >
                          <i className="bi bi-person-fill me-2"></i> Profile
                        </NavLink>
                      ) : (
                        <NavLink
                          to={ROUTES.LOGIN.path}
                          onClick={handleNavLinkClick}
                        >
                          <i className="bi bi-person-fill me-2"></i> Login
                        </NavLink>
                      )}
                    </li>
                  </ul>
                </nav>
              </div>
            </div>
          </div>
        </div>
      </header>
      {/* ===============  header area end =============== */}

    </>
  );
}

export default HomeOneHeader;
